import { UserMenu } from "./user-menu.tsx"

import * as UI from "@iyk/ui"
import * as React from "react"

import { useLocation } from "react-router"
import { Assets as GlobalAssets } from "../../../packages/assets.ts"
import { config } from "../../../packages/config.ts"
import { LoginStep, type Profile } from "../profile.ts"
import { Link, Routes } from "./link.tsx"
import { LoginSheet } from "./login-sheet.tsx"
import { useScrollVisibility } from "./use-scroll-visibility.tsx"

export const Header = ({ user }: { user?: Profile.User }) => {
  const { headerRef, isHidden, isScrolled } = useScrollVisibility()

  const [loginStep, setLoginStep] = React.useState<LoginStep>(LoginStep.Login())
  const [isLoginSheetOpen, setIsLoginSheetOpen] = React.useState(false)

  const currentRoute = useLocation().pathname

  // If the user is logged in and the login sheet is open and the login step is VerifyOtp, close the login sheet
  if (user && isLoginSheetOpen && LoginStep.$is("VerifyOtp")(loginStep)) {
    setIsLoginSheetOpen(false)
  }

  return (
    <header ref={headerRef} className={classForHeader({ isHidden, isScrolled })}>
      <Link to={Routes.home} className="content-center">
        <img
          src={GlobalAssets.images.logo}
          alt={`${config.general.name} logo`}
          className="h-5 w-auto"
        />
      </Link>
      {user ? (
        <UserMenu
          username={user.username}
          userId={user.id}
          showCount={user.attendedShowIds.length}
          merchCount={user.ownedMerchSkuIds.length}
        />
      ) : (
        <UI.Button type="button" kind="shaded" size="sm" onClick={() => setIsLoginSheetOpen(true)}>
          로그인
        </UI.Button>
      )}
      <LoginSheet
        returnTo={currentRoute}
        loginStep={loginStep}
        setLoginStep={setLoginStep}
        open={isLoginSheetOpen}
        setOpen={setIsLoginSheetOpen}
      />
    </header>
  )
}

const classForHeader = UI.cva(
  [
    "text-gray-12 sticky",
    "z-30 top-0 left-0 w-full h-[var(--header-height)] p-4",
    "flex item-center justify-between",
    "transition-all duration-300 ease-in-out",
  ],
  {
    variants: {
      isHidden: {
        true: "top-[calc(var(--header-height)*-1)]",
      },
      isScrolled: {
        true: "backdrop-blur-md bg-black/[85%]",
      },
    },
  },
)
